export default __webpack_public_path__ + "static/media/dragoge.9b06e4de.ogg";